(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

jQuery(document).ready(function () {

  var href = window.location.href;
  var url = new URL(href);

  var currentModel = url.searchParams.get('model');
  var configData = {
    firstName: '',
    lastName: '',
    email: '',
    zip: '',
    configType: 'tt',
    configStep: 'length',
    model: currentModel || '',
    modelName: document.querySelector("h1").innerText,
    productImage: jQuery(".pl-imgSlide").find("img").attr("src")
  };

  try {
    var data = JSON.parse(localStorage.getItem('configData'));
    if (data) {
      data = {
        firstName: data.firstName || '',
        lastName: data.lastName || '',
        email: data.email || '',
        zip: data.zip || ''
      };
      Object.assign(configData, data);
    }
  } catch (e) {}

  sessionStorage.setItem('configData', JSON.stringify(configData));
  localStorage.setItem('configData', JSON.stringify(configData));

  jQuery('.btn-length').click(function (e) {
    e.preventDefault();
    var imgToShow = jQuery(this).attr('data-img');
    jQuery('#main-ext-img').attr('src', imgToShow);
    var sleeps = jQuery(this).attr('data-sleeps');
    jQuery('.sleep-capacity').text(sleeps);

    var currentParams = location.href.split('?')[1];
    var selectedLength = jQuery(this).attr('data-value');
    var newParams = currentParams + '&length=' + selectedLength;

    var configData = JSON.parse(sessionStorage.getItem('configData'));

    configData.length = selectedLength;

    if (!configData.productImage) {
      configData.productImage = $('#main-ext-img').attr('src');
    }

    sessionStorage.setItem('configData', JSON.stringify(configData));
    localStorage.setItem('configData', JSON.stringify(configData));

    jQuery('.pl-navNextBtn, .btn-next').attr('href', '/configurator/tt/floor-plan/' + buildURLParams());
    jQuery('.pl-navNextBtn, .btn-next').removeClass('disabled');
  });
});

},{}]},{},[1]);
